import React, { useCallback } from 'react';
import Toast from 'src/components/Toast';
import usePaginationObservable from 'src/hooks/usePagination';
import Header from 'src/routes/Layout/Header';
import { Container } from 'src/routes/Layout/Page/styles';
import reservationService from 'src/service/reservation';
import DataGrid from './components/DataGrid';
import Filters from './components/Filters';
import Refresh from './components/Refresh';
import { Content, LocalHeader, Title } from "./styles";

export const dateFormat = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };

const messages = {
  'reservation-not-found': (id: number) => `Reserva não encontrada: ${id}`,
  'unauthorized-user': (id: number) => `Cancelamento não autorizado: ${id}`,
  'reservation-has-already-canceled': (id: number) => `A reserva ${id} já foi cancelada.`
};

const ReservationReport = () => {
  const [params, mergeParams, loading, data, error, , refresh] = usePaginationObservable(
    params => reservationService.report(params),
    { orderBy: 'date', orderDirection: 'asc' },
    []
  );

  const toast = Toast();

  const handleRefresh = useCallback((): Promise<void> => {
    return new Promise((res, rej) => {
      try {
        refresh();
        res();
      }
      catch (err) {
        rej(err)
      }
    });
  }, [refresh]);

  const handleCancel = useCallback((ids: number[]) => {
    reservationService.cancel(ids)
      .then(() => {
        toast.success('A(s) reserva(s) foi(foram) cancelada(s) com sucesso!');
        refresh();
      })
      .catch(err => {
        const { response: { data } } = err;
        let messageValue = '';

        if (typeof messages[data.message] === 'function') messageValue = messages[data.message](data.value);
        else messageValue = messages[data.message];

        if (data.message === 'reservation-has-already-canceled') refresh();

        toast.error(messageValue);
      });
  }, [refresh, toast]);

  return (
    <Container>
      <Header />
      <Content>
        <LocalHeader>
          <Title>Relatório</Title>
          <Refresh onClick={handleRefresh} loading={loading} />
        </LocalHeader>
        <Filters params={params} mergeParams={mergeParams} />
        <DataGrid
          checkbox={true}
          data={data}
          error={error}
          loading={loading}
          mergeParams={mergeParams}
          onCancel={handleCancel}
          params={params} />
      </Content>
    </Container>
  );
}

export default ReservationReport;